import React from 'react';
import { ApiUrlData, WebUrlData } from '@base-configs';
import { InitialValuePageProviderEntity } from '@base-entities';
import { PageProvider } from '@base-providers';
import { PageController } from '@base-components';

import { WorkflowConfigurationEntity } from '../../domain/entities';

import PageIndex from '../pages';

export function WorkflowConfigurationFactory() {
  const InitialValue: InitialValuePageProviderEntity<WorkflowConfigurationEntity> = {
    moduleKey: 'configuration-workflow-pages', // make sure this key unique each module
    webUrl: WebUrlData.configuration_workflow,
    apiUrl: ApiUrlData.workflow,
  };

  return (
    <PageProvider initialValue={InitialValue}>
      <PageController PageIndex={PageIndex} />
    </PageProvider>
  );
}
